import { AxiosError } from 'axios';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { CustomError } from '@trukt/types/CustomError';
import { TrimbleMapsSingleSearchApi } from '@trukt/portal-utils/TrimbleMapsSingleSearchApi';
import {
  fromTrimbleMapsSingleSearchResponseToSearchOptions,
  FromTrimbleMapsSingleSearchResponseToSearchOptionsResult,
} from '@trukt/portal-utils/fromTrimbleMapsSingleSearchResponseToSearchOptions';

type QueryKey = string[];
type UseAddressQueryWithApiOptions = Omit<
  UseQueryOptions<
    FromTrimbleMapsSingleSearchResponseToSearchOptionsResult[],
    AxiosError<CustomError>,
    FromTrimbleMapsSingleSearchResponseToSearchOptionsResult[],
    QueryKey
  >,
  'queryKey' | 'queryFn'
>;

type UseAddressQueryWithApiResult = {
  queryKey: QueryKey;
  query: UseQueryResult<
    FromTrimbleMapsSingleSearchResponseToSearchOptionsResult[],
    AxiosError<CustomError>
  >;
};

type UseAddressQueryWithApiProps = (
  api: TrimbleMapsSingleSearchApi,
  criteria: string,
  options?: UseAddressQueryWithApiOptions,
) => UseAddressQueryWithApiResult;

export const useAddressQueryWithApi: UseAddressQueryWithApiProps = (api, criteria, options) => {
  const queryKey = ['ADDRESS', criteria];
  const query = useQuery({
    queryKey: queryKey,

    queryFn: async () => {
      const response = await api.search({
        queryParams: { query: criteria },
      });
      return fromTrimbleMapsSingleSearchResponseToSearchOptions(response.data);
    },

    enabled: !!criteria.trim(),
    ...options,
  });

  return {
    queryKey,
    query,
  };
};
